<template>
  <div class="tw-p-4">
    <div
        v-if="frames.length > 0"
        class="tw-grid tw-grid-cols-3 tw-gap-4"
    >
      <div
          v-for="(frame, index) in frames"
          :key="frame.id"
          class="tw-bg-white tw-p-4 tw-rounded tw-shadow tw-flex tw-flex-col"
      >
        <img
            :src="frame.image"
            alt="Frame"
            class="tw-mb-2 tw-h-120 tw-w-auto tw-object-contain"
        >
        <h3 class="tw-font-semibold tw-mb-2">
          Frame #{{ index + 1 }} <br>
          <span v-if="frame.external_reference && frame.external_reference.length > 0">
            Reference: {{ frame.external_reference }}
          </span>
          <span v-else-if="frame.raw_data.reference && frame.raw_data.reference.length > 0">
            Reference: {{ frame.raw_data.reference }}
          </span>
        </h3>
        <p class="tw-text-gray-800 tw-mb-4">
          £{{ frame.price }}
        </p>
        <p class="tw-text-gray-800 tw-mb-4">
          Qty: {{ frame.quantity }}
        </p>
        <div class="tw-mt-auto tw-flex tw-justify-between">
          <button
              class="tw-bg-blue-500 hover:tw-bg-blue-400 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-flex tw-items-center tw-group"
              @click="$emit('edit', frame)"
          >
            <svg
                class="tw-h-5 tw-w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </button>
          <button
              class="tw-bg-red-500 hover:tw-bg-red-400 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-flex tw-items-center tw-group"
              @click="$emit('delete', frame)"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="tw-bi tw-bi-trash"
                viewBox="0 0 16 16"
            >
              <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
              />
              <path
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
              />
            </svg>
          </button>
          <button
              class="tw-bg-green-500 hover:tw-bg-green-400 tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded tw-flex tw-items-center tw-group"
              @click="$emit('customize', frame)"
          >
            <svg
                class="tw-h-5 tw-w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.207V18.5H3.793l11.439-11.439z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div
        v-else
        class="tw-h-screen tw-flex tw-items-center tw-justify-center"
    >
      <h1 class="tw-text-[5em] tw-text-[#d9d9d9] tw-font-bold">
        This quote is still empty
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  props: ['frames'],
  emits: ['customize']
};
</script>